import PhoneInput from '@src/components/checkout/components/PhoneInput/phone-input';
import Loader from '@src/components/loader';
import { getCategoryProps, getFitmentModels, setFitmentTarget, setProduct } from '@src/redux/actions';
import axios from 'axios';
import classNames from 'classnames';
import { find, orderBy, reverse, sortBy } from 'lodash';
import Link from 'next/link';
import React, { Component, useContext, useEffect, useRef, useState } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';

const customStyles = {
	menuList: (provided, state) => ({
		...provided,
		// maxHeight: '200px',
	}),
	control: (provided, state) => ({
		...provided,
		background: '#fff',
		minHeight: '33px',
		height: '33px',
		borderRadius: '3px',
	}),

	valueContainer: (provided, state) => ({
		...provided,
		height: '33px',
		padding: '0 6px',
	}),

	input: (provided, state) => ({
		...provided,
		margin: '0px',
	}),

	indicatorsContainer: (provided, state) => ({
		...provided,
		height: '33px',
	}),
};

function categorySearch(props) {
	const { store } = useContext(ReactReduxContext);
	const { type, modalVisible } = props;
	const [loading, setLoading] = useState(false);

	let lastIndexAvailable = props.fitmentOptions - 1;
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState();
	const [vehicleData, setVehicleData] = useState([]);
	const [phoneNumber, setPhoneNumber] = useState('');
	const [fitmentStatus, setFitmentStatus] = useState('target-missing');
	const [vehicleSpecs, setVehicleSpecs] = useState('');
	const [urlSlug, setUrlSlug] = useState('');
	const [modalVisibility, setModalVisibility] = useState(false);

	let names = ['Make', 'Model', 'Year', 'Engine'];
	const initialCategory = props.categorySlug || 'vehicle-batteries-car-or-truck';

	useEffect(() => {
		// Check if we have the fitment data saved
		if (props.fitmentTarget && props.fitmentTarget.searchValue) {
			// console.log('props.fitmentTarget', props.fitmentTarget);

			// Fill necessary variables
			setVehicleSpecs(props.fitmentTarget.target);
			setUrlSlug(props.fitmentTarget.fullUrlSlug); // If we are on checkout page
			if (type === 'input-label') {
				// console.log('is input-label')
				// Check if we have saved data
				// Check if any item from the cart is previously checked and valid
				// If at least 1 is true
				if (props.fitmentTarget.verifiedFitment && props.fitmentTarget.verifiedFitment.productId) {
					// Update redux store
					props.updateFormValue(props.fitmentTarget.target);

					let atLeastOneProductFits = false;
					props.cartProducts &&
						props.cartProducts.forEach(element => {
							if (element.bigCommerceId === props.fitmentTarget.verifiedFitment.productId) {
								atLeastOneProductFits = props.fitmentTarget.verifiedFitment.fits;
							}
						});

					// Inform component that the product in the cart is verified
					if (atLeastOneProductFits) {
						setFitmentStatus('success');
					} else {
						setFitmentStatus('error');
					}
				}

				// If not checked before, but we have fitment target,
				// then check now. This happens after user lands on checkout after
				// collection pages without reaching single product page
				else {
					verifyFitment(
						props.geolocation.latitude,
						props.geolocation.longitude,
						props.fitmentTarget.fullUrlSlug,
						props.idToCompare,
						props.fitmentTarget.target
					);
				}
			}

			// If we have fitment data, but this particular fitment model was not checked against the available product ID
			// Do the test again
			// Happens when use went trough the process of filtering models on category pages, but never reached the single product where this
			// components fires.
			else {
				setUrlSlug(`${props.categorySlug}-${props.fitmentTarget.searchValue}`);
				// Check the fitment
				verifyFitment(
					props.geolocation.latitude,
					props.geolocation.longitude,
					props.fitmentTarget.fullUrlSlug,
					props.idToCompare,
					props.fitmentTarget.target
				);
			}
		}

		// Get initial models and start building the category ID in case we need it
		store.dispatch(getFitmentModels(initialCategory, 0));
	}, []);

	useEffect(() => {
		setLoading(false);
	}, [props.fitmentOptions]);

	useEffect(() => {
		if (fitmentStatus === 'initial') {
			setVehicleSpecs('');
		}
	}, [fitmentStatus]);

	function onSelectionChange(value, index) {
		let newData = [...vehicleData];
		newData[index - 1] = value;

		// In case we select one of the earlier selections
		// reset everything after current selection
		newData = newData.slice(0, index);
		setVehicleData(newData);
		store.dispatch(getFitmentModels(value.urlSlug, index));
	}

	function verifyFitment(latitude, longitude, urlSlug, idToCompare, target) {
		setFitmentStatus('loading');
		const apiUrl = 'https://3cg1obtmoj.execute-api.us-west-2.amazonaws.com/checkout/crossreference/products';
		const xrefPath = `${apiUrl}/${urlSlug}?&lat=${latitude}&lng=${longitude}`;

		axios.get(xrefPath, { crossdomain: true }).then(data => {
			const isCompatible = find(data.data.product, ['bigCommerceId', idToCompare]);

			setFitmentStatus(isCompatible ? 'success' : 'error');
			setModalVisibility(false);
			props.setModalVisibleFromExternal && props.setModalVisibleFromExternal(false);

			// Add target into redux state
			// searhValue is target slug subtracted from the full slug i.e. category is removed. More flexible for multiple categories.
			store.dispatch(
				setFitmentTarget({
					target: target,
					searchValue: urlSlug.split(`${props.categorySlug}-`)[1],
					fullUrlSlug: urlSlug,
					verifiedFitment: { productId: idToCompare, urlSlug: urlSlug, fits: isCompatible ? true : false },
				})
			);

			if (isCompatible) {
				store.dispatch(setProduct(isCompatible));
			}

			// Update the delivery address form
			// Fires only on Variables
			props.updateFormValue && props.updateFormValue(target);
		});
	}

	function renderStatusElements() {
		if (fitmentStatus === 'loading') {
			return type === 'input-label' ? (
				<span className="loading">
					{' '}
					- <i className="fas fa-circle-notch fa-spin"></i> Loading
				</span>
			) : (
				<div className={`fitment-status loading ${type}`}>
					<div className="icon">
						<i className="fas fa-circle-notch fa-spin"></i>
					</div>
					<div className="text">
						<h6>Verifying the Fitment</h6>
						<p>Please wait...</p>
					</div>
				</div>
			);
		}

		if (fitmentStatus === 'success') {
			return type === 'input-label' ? (
				<span className="success">
					{' '}
					- <i className="fad fa-check-circle"></i> Fits Your Product
				</span>
			) : (
				<div className={`fitment-status fits ${type}`}>
					<div className="icon">
						<i className="fas fa-check"></i>
					</div>
					<div className="text">
						<h6>Fits your</h6>
						<p>{vehicleSpecs}</p>
					</div>

					<div className="button-container">
						<button
							onClick={() => {
								setModalVisibility(true);
							}}>
							Change Vehicle
						</button>
					</div>
				</div>
			);
		} else if (fitmentStatus === 'error') {
			return type === 'input-label' ? (
				<span className="error">
					{' '}
					- <i className="far fa-ban"></i> Does not fit{' '}
					<button
						onClick={() => {
							setModalVisibility(true);
						}}
						type="button">
						Change
					</button>
				</span>
			) : (
				<div className={`fitment-status does-not-fit ${type}`}>
					<div className="icon">
						<i className="far fa-ban"></i>
					</div>
					<div className="text">
						<h6>Does not fit your</h6>
						<p>
							{vehicleSpecs}{' '}
							<span
								onClick={() => {
									setModalVisibility(true);
								}}
								className="change-vehicle">
								(Change)
							</span>
						</p>
						<Link className="btn" href={`/category/${urlSlug}`}>
							<a>View Compatible Products</a>
						</Link>
					</div>
				</div>
			);
		} else if (fitmentStatus === 'target-missing') {
			return type === 'input-label' ? (
				<span className="normal">
					{' '}
					-{' '}
					<button
						onClick={() => {
							setModalVisibility(true);
						}}
						type="button">
						<i className="fal fa-info-circle"></i> Add Vehicle
					</button>
				</span>
			) : (
				<div className={`fitment-status target-missing ${type}`}>
					<div className="icon">
						<i className="fal fa-info-circle"></i>
					</div>
					<div className="text">
						<h6>Verify fitment with your vehicle</h6>
						<p>
							<button
								onClick={() => {
									setModalVisibility(true);
								}}>
								Add Vehicle
							</button>
						</p>
					</div>
				</div>
			);
		}
	}

	function renderFitmentForm(isExtended) {
		return (
			<div className={`fitment-verification ${type} `}>
				<div className="inner-wrapper">
					<div className="form">
						<div className="form-items-container">
							<h6>
								<i className="fal fa-info-circle"></i> Verify fitment with your vehicle
							</h6>

							<div className="form-items">
								{(loading || fitmentStatus === 'loading') && (
									<div className="loading-container">
										<div className="loading">
											<Loader />
										</div>
									</div>
								)}
								{names.map((item, index) => {
									const yearIndex = 2;
									const options = props.fitmentOptions[index] ? props.fitmentOptions[index] : [];
									return (
										<div
											className={classNames(
												'form-item',
												{ disabled: !props.fitmentOptions[index] },
												{ 'last-index-available': lastIndexAvailable === index },
												{ active: props.fitmentOptions.length - 1 === index }
											)}
											key={index}>
											{isExtended && <label>{names[index]}</label>}
											<Select
												styles={customStyles}
												isDisabled={!props.fitmentOptions[index]}
												closeMenuOnSelect={true}
												blurInputOnSelect={true}
												// If it's a year selection, sort and reverse
												options={
													index === yearIndex
														? reverse(sortBy(options, 'label'))
														: sortBy(options, 'label')
												}
												value={vehicleData[index] ? vehicleData[index] : null}
												placeholder={`Select ${item}`}
												onChange={value => {
													setLoading(true);
													onSelectionChange(value, index + 1);
													setUrlSlug(value.urlSlug);
													setVehicleSpecs(value.searchValue);
													setFitmentStatus('target-missing');

													// If we reached last input submit the form and other actions
													if (index === names.length - 1) {
														verifyFitment(
															props.geolocation.latitude,
															props.geolocation.longitude,
															value.urlSlug,
															props.idToCompare,
															value.searchValue
														);
													}
												}}
											/>
											{simpleValidator.current.message(
												names[index],
												vehicleData[index],
												'required'
											)}
										</div>
									);
								})}

								{/* Will be used on order page with amazon orders */}
								{type === 'order-page-fitment' && (
									<div
										className={`form-item ${
											!props.fitmentOptions[names.length] ? 'disabled' : ''
										}`}>
										<PhoneInput
											disabled={!props.fitmentOptions[names.length]}
											type="nestedObject"
											label={'Phone Number'}
											value={'phoneNumber'}
											placeholder="Phone Number"
											name="phoneNumber"
											onChange={val => setPhoneNumber(val)}
										/>
										{simpleValidator.current.message('Phone Number', phoneNumber, 'required')}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<Modal
				classNames={{
					modal: `fitment-verification-in-modal`,
					closeButton: 'close-btn',
				}}
				open={modalVisibility || props.modalVisibleFromExternal}
				onClose={() => {
					props.setModalVisibleFromExternal && props.setModalVisibleFromExternal(false);
					setModalVisibility(false);
				}}>
				{renderFitmentForm(true)}
			</Modal>
			{renderStatusElements()}
		</>
	);
}

const mapStateToProps = state => ({
	geolocation: state.geolocation,
	fitmentOptions: state.category.fitmentOptions,
	fitmentTarget: state.category.fitmentTarget,
	category: state.category,
	masterProvider: state.masterProvider,
});

export default connect(mapStateToProps, {
	getCategoryProps,
	getFitmentModels,
	setFitmentTarget,
})(categorySearch);
